import {setActiveIncident, setActivePoint, setActivePrescription, toggleIncidentType} from '../actions';
import * as ActionTypes from '../actions/actionTypes';
import {
  populateBurnPolgonsAsync,
  populateBurnsDataAsync,
  populateBushfiresDataAsync,
  populateCurrentBurntAreaAsync
} from '../actions/populate_incident_data';
import {INCIDENT_TYPE_KEYS, MODES} from '../Constants';
import {incidentPrescriptionsLayerIsActive} from '../utils/prescriptions_utils';

const POLLING_INTERVAL_MS = 5 * 60 * 1000;

export const incident = store => next => action => {
  const dispatch = store.dispatch;
  // Pre Action behaviour
  if (action.type === ActionTypes.SET_ACTIVE_INCIDENT_FEATURE) {
    dispatch(setActivePrescription(action.prescriptionId));
    dispatch(setActivePoint(action.latlng.lat, action.latlng.lng, action.name));
  }

  // Complete the current action
  const result = next(action);
  const state = store.getState();

  // Post Action behaviour
  const layers = state.incidents.layers;
  if (action.type === ActionTypes.POPULATE_BURN_DETAILS) {
    if (state.incidents.activateWhenLoaded) {
      dispatch(setActiveIncident(state.incidents.activateWhenLoaded));
    }
  }
  if (action.type === ActionTypes.TOGGLE_INCIDENT_TYPE) {
    if (INCIDENT_TYPE_KEYS.BUSHFIRES === action.id) {
      const layer = layers.find(layer => layer.id === action.id);
      if (layer.active) {
        let poller;
        poller = setInterval(() => dispatch(populateBushfiresDataAsync(poller)), POLLING_INTERVAL_MS);
        dispatch(populateBushfiresDataAsync(poller));
      } else if (layer.poller) {
        clearInterval(layer.poller);
      }
    } else if (INCIDENT_TYPE_KEYS.CURRENT_BURNT_AREA === action.id) {
      const layer = layers.find(layer => layer.id === action.id);
      if (layer.active) {
        dispatch(populateCurrentBurntAreaAsync());
      }
    } else if (action.id.startsWith('BURNS')) {
      const layer = layers.find(layer => layer.id === action.id);
      if (layer.active) {
        let poller;
        poller = setInterval(() => {
          if (!incidentPrescriptionsLayerIsActive(layers)) {
            dispatch(populateBurnsDataAsync(action.id, poller));
          }
        }, POLLING_INTERVAL_MS);
        dispatch(populateBurnsDataAsync(action.id, poller));
      } else if (layer.poller) {
        clearInterval(layer.poller);
      }
    }
  } else if (action.type === ActionTypes.SET_APP_MODE) {
    const { app_mode } = state.app;
    layers.filter(layer => layer.active && layer.only_in_app_mode && layer.only_in_app_mode !== app_mode)
          .forEach((layer) => {
            // If the layer does not exist in this app mode, toggle it off.
            dispatch(toggleIncidentType(layer.id));
          });

    // Load incident polygons if in planning mode
    if (app_mode === MODES.PLANNED_BURNS) {
      layers.filter(l => l.id === INCIDENT_TYPE_KEYS.INCIDENT_POLYGONS)
      // There should only be one, but using forEach is an easy way to prevent errors when the config is missing.
            .forEach((layer) => {
              dispatch(populateBurnPolgonsAsync(layer));
            });
    }

    // Turn on the Burn layers if entering planned burns mode
    if (app_mode === MODES.PLANNED_BURNS && !state.view.disclaimer_open) {
      layers.forEach(l => {
        if (!l.active && l.id.startsWith('BURNS_')) {
          dispatch(toggleIncidentType(l.id));
        }
      });
    }
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/middleware/incidentMiddleware.js